import type { InventoryMessages } from "./messages.en";
/** Untranslated phrases fall back to English in the message runtime. */
export const inventoryEs: Partial<Record<keyof InventoryMessages, string>> = {
  "pos.supplierReturn.title": "Devoluciones al proveedor",
  "pos.supplierReturn.help": "Devuelva cantidades de su recepción y capa de costo originales. Los pedidos y créditos de cuentas por pagar se gestionan por separado.",
  "pos.supplierReturn.quantity": "Cantidad a devolver · {name}",
  "pos.supplierReturn.available": "Recepción original: {received} · Disponible en esta capa: {available} · Costo unitario: {cost}",
  "pos.supplierReturn.reason": "Motivo de devolución o corrección",
  "pos.supplierReturn.reference": "Referencia de devolución o corrección",
  "pos.supplierReturn.date": "Fecha de devolución o corrección",
  "pos.supplierReturn.review": "Revisar devolución al proveedor",
  "pos.supplierReturn.undo": "Revisar anulación",
  "pos.supplierReturn.undoHelp": "Esta corrección restaura todas las asignaciones de la devolución al costo original. No recibe otra entrega ni cambia el pedido.",
  "pos.supplierReturn.ack": "Verifiqué los artículos, costos originales y referencia del proveedor. Esto solo modifica existencias.",
  "pos.supplierReturn.confirm": "Confirmar cambio revisado",
  "pos.supplierReturn.retry": "Reintentar la misma solicitud",
  "pos.supplierReturn.unknown": "El resultado no está confirmado. Conserve la revisión y reintente la misma solicitud, o recargue el historial para comprobar el resultado.",
  "pos.supplierReturn.invalid": "Ingrese motivo, referencia, fecha y al menos una cantidad positiva exacta.",
  "pos.supplierReturn.cost": "Costo de existencias del cambio",
  "pos.supplierReturn.beforeAfter": "Existencias: {before} → {after}",
  "pos.supplierReturn.posted": "Cambio de existencias registrado",
  "pos.supplierReturn.view": "Ver cambio registrado",
  "pos.supplierReturn.history": "Historial de devoluciones",
  "pos.supplierReturn.empty": "No hay devoluciones para esta recepción.",
  "pos.supplierReturn.new": "Nueva devolución",
  "pos.supplierReturn.allHistory": "Ver todo el historial de existencias",
  "pos.supplierReturn.back": "Volver a recepción",
  "pos.supplierReturn.loadAgain": "Recargar historial de recepción",
  "pos.supplierReturn.undoSelection": "Anular devolución seleccionada",
  "pos.stockOps.supplier_return": "Devolución al proveedor",
  "pos.stockOps.supplier_return_undo": "Anular devolución al proveedor",
  "pos.inventory.stockOperationsLink": "Correcciones y traslados",
  "pos.stockOps.title": "Operaciones de inventario",
  "pos.stockOps.detailTitle": "Detalles de la operación",
  "pos.stockOps.subtitle": "Revise correcciones, traslados y reversiones de recibos inmutables.",
  "pos.stockOps.scopeNote": "El inventario en cero aquí no representa el saldo inicial de Jonas. Estas operaciones no cambian precios, impresión de ventas, cuentas por pagar ni el libro mayor.",
  "pos.stockOps.readOnlyNote": "Puede consultar el historial de operaciones y movimientos. Se requiere permiso de gestión de POS para previsualizar o registrar una operación.",
  "pos.stockOps.newOperation": "Nueva operación de inventario",
  "pos.stockOps.steps": "1. Indique el motivo y las cantidades → 2. Revise las cantidades anteriores y nuevas → 3. Confirme y registre.",
  "pos.stockOps.details": "Detalles de la operación",
  "pos.stockOps.operationType": "Tipo de operación",
  "pos.stockOps.adjustment": "Ajuste",
  "pos.stockOps.transfer": "Traslado",
  "pos.stockOps.receiptReversal": "Reversión de recibo",
  "pos.stockOps.stockLocation": "Ubicación de inventario",
  "pos.stockOps.sourceLocation": "Ubicación de origen",
  "pos.stockOps.destinationLocation": "Ubicación de destino",
  "pos.stockOps.chooseLocation": "Elija una ubicación",
  "pos.stockOps.effectiveDate": "Fecha efectiva",
  "pos.stockOps.postedReceipt": "Recibo registrado",
  "pos.stockOps.choosePostedReceipt": "Elija un recibo registrado",
  "pos.stockOps.receiptIdLookup": "Buscar ID del recibo",
  "pos.stockOps.receiptIdHint": "Elija un recibo reciente o pegue su UUID para buscar uno anterior.",
  "pos.stockOps.lookingUpReceipt": "Buscando recibo…",
  "pos.stockOps.receiptFound": "Recibo registrado {reference} en {location}.",
  "pos.stockOps.receiptMustBePosted": "El recibo no está registrado y no se puede revertir.",
  "pos.stockOps.findVariant": "Buscar artículo, variante o SKU",
  "pos.stockOps.variantHint": "Escriba al menos dos caracteres. Los artículos archivados también aparecen.",
  "pos.stockOps.addVariant": "Agregar {name}",
  "pos.stockOps.narrowSearch": "Afine la búsqueda para ver más resultados.",
  "pos.stockOps.lines": "Variantes y cantidades",
  "pos.stockOps.quantityLine": "Cantidad, línea {line}",
  "pos.stockOps.signedQuantityHint": "Indique un ajuste con signo. El positivo agrega inventario; el negativo lo reduce.",
  "pos.stockOps.positiveQuantityHint": "Indique una cantidad positiva para trasladar.",
  "pos.stockOps.removeLine": "Quitar línea {line}",
  "pos.stockOps.reversalLinesNote": "La reversión usa exactamente las líneas del recibo registrado.",
  "pos.stockOps.reason": "Motivo",
  "pos.stockOps.previewing": "Preparando vista previa…",
  "pos.stockOps.previewAction": "Previsualizar operación",
  "pos.stockOps.previewTitle": "Revise el impacto en inventario",
  "pos.stockOps.previewSummary": "{kind} con fecha efectiva {date}",
  "pos.stockOps.previewLines": "Cantidades de la operación",
  "pos.stockOps.change": "Cambio",
  "pos.stockOps.before": "Antes",
  "pos.stockOps.after": "Después",
  "pos.stockOps.acknowledge": "Revisé las ubicaciones y cantidades y deseo registrar esta operación inmutable.",
  "pos.stockOps.immutableNotice": "Las operaciones registradas y sus movimientos son permanentes y no se pueden editar ni eliminar.",
  "pos.stockOps.posting": "Registrando…",
  "pos.stockOps.postOperation": "Registrar operación",
  "pos.stockOps.stalePreview": "El inventario cambió después de esta vista previa. Cargue una vista previa nueva antes de registrar.",
  "pos.stockOps.reloadPreview": "Cargar vista previa nueva",
  "pos.stockOps.postedTitle": "Operación registrada",
  "pos.stockOps.postedSummary": "Operación {id} registrada el {at}.",
  "pos.stockOps.viewPostedOperation": "Ver operación registrada",
  "pos.stockOps.startNewOperation": "Iniciar otra operación de inventario",
  "pos.stockOps.historyTitle": "Historial de operaciones",
  "pos.stockOps.action": "Acción",
  "pos.stockOps.viewDetails": "Ver detalles",
  "pos.stockOps.loadingMore": "Cargando…",
  "pos.stockOps.loadMore": "Cargar más",
  "pos.stockOps.emptyHistory": "Aún no hay operaciones",
  "pos.stockOps.emptyHistoryHelp": "Aquí aparecerán las correcciones y los traslados registrados.",
  "pos.stockOps.movementsTitle": "Historial de movimientos",
  "pos.stockOps.filterLocation": "Filtrar por ubicación",
  "pos.stockOps.allLocations": "Todas las ubicaciones",
  "pos.stockOps.date": "Fecha",
  "pos.stockOps.emptyMovements": "Aún no hay movimientos de inventario.",
  "pos.stockOps.backToHistory": "Volver a operaciones",
  "pos.stockOps.backToInventory": "Volver a inventario",
  "pos.stockOps.detailMetadata": "Operación {id} · efectiva {date} · registrada {at}",
  "pos.stockOps.receipt": "Recepción",
  "pos.stockOps.opening": "Saldo inicial",
  "pos.stockOps.sale": "Deducción por venta",
  "pos.stockOps.saleReturn": "Devolución física de venta",
};
